<template>
  <ToastProvider>
    <div v-for="notification in notifications" :key="notification.id">
      <ToastRoot :open="true" :duration="notification.duration"
        @update:open="(open) => !open && removeNotification(notification.id)" :class="[
          'group pointer-events-auto relative flex w-full max-w-md items-center justify-between space-x-4 overflow-hidden rounded-lg border-l-4 p-4 pr-8 shadow-xl transition-all backdrop-blur-sm',
          'data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=move]:transition-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=closed]:slide-out-to-right-full data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full',
          notification.type === 'success' ? 'border-l-green-500 bg-white/95 dark:bg-gray-900/95 text-green-900 dark:text-green-100' : '',
          notification.type === 'error' ? 'border-l-red-500 bg-white/95 dark:bg-gray-900/95 text-red-900 dark:text-red-100' : '',
          notification.type === 'warning' ? 'border-l-yellow-500 bg-white/95 dark:bg-gray-900/95 text-yellow-900 dark:text-yellow-100' : '',
          notification.type === 'info' ? 'border-l-cyan-500 bg-white/95 dark:bg-gray-900/95 text-cyan-900 dark:text-cyan-100' : '',
        ]">
        <div class="flex items-start space-x-3 w-full">
          <div class="flex-shrink-0 mt-0.5">
            <div :class="[
              'flex items-center justify-center rounded-full p-1',
              notification.type === 'success' ? 'bg-green-100 dark:bg-green-900/30' : '',
              notification.type === 'error' ? 'bg-red-100 dark:bg-red-900/30' : '',
              notification.type === 'warning' ? 'bg-yellow-100 dark:bg-yellow-900/30' : '',
              notification.type === 'info' ? 'bg-cyan-100 dark:bg-cyan-900/30' : '',
            ]">
              <CheckCircle2 v-if="notification.type === 'success'" class="h-5 w-5 text-green-600 dark:text-green-400" />
              <XCircle v-else-if="notification.type === 'error'" class="h-5 w-5 text-red-600 dark:text-red-400" />
              <AlertTriangle v-else-if="notification.type === 'warning'"
                class="h-5 w-5 text-yellow-600 dark:text-yellow-400" />
              <Info v-else-if="notification.type === 'info'" class="h-5 w-5 text-cyan-600 dark:text-cyan-400" />
            </div>
          </div>

          <div class="flex-1 min-w-0">
            <ToastTitle v-if="notification.title" class="text-sm font-semibold leading-tight">
              {{ notification.title }}
            </ToastTitle>
            <ToastDescription :class="[
              'text-sm leading-relaxed break-words text-gray-600 dark:text-gray-300',
              notification.title ? 'mt-1' : 'font-medium'
            ]">
              {{ notification.message }}
            </ToastDescription>
          </div>
        </div>

        <ToastClose
          class="absolute right-2 top-2 rounded-md p-1 text-gray-400 opacity-0 transition-all hover:text-gray-900 dark:hover:text-gray-100 hover:bg-gray-100 dark:hover:bg-gray-800 focus:opacity-100 focus:outline-none focus:ring-2 focus:ring-offset-1 group-hover:opacity-100"
          @click="removeNotification(notification.id)">
          <X class="h-4 w-4" />
          <span class="sr-only">Cerrar</span>
        </ToastClose>
      </ToastRoot>
    </div>

    <ToastViewport
      class="fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse p-4 sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col md:max-w-[420px]" />
  </ToastProvider>
</template>

<script setup>
import {
  ToastProvider,
  ToastRoot,
  ToastTitle,
  ToastDescription,
  ToastClose,
  ToastViewport
} from 'radix-vue'
import { CheckCircle2, XCircle, AlertTriangle, Info, X } from 'lucide-vue-next'
import { useNotificationStore } from '@/stores/notification'
import { storeToRefs } from 'pinia'

const notificationStore = useNotificationStore()
const { notifications } = storeToRefs(notificationStore)
const { remove: removeNotification } = notificationStore
</script>

<style scoped>
/* Radix Toast animations are handled automatically */
</style>
